import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharterCaptainsComponent } from './charter-captains.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { CaptainSearchModule } from './captain-search/captain-search.module';

@NgModule({
  declarations: [CharterCaptainsComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatChipsModule,
    MatButtonModule,
    CaptainSearchModule,
    MatIconModule,
  ],
})
export class CharterCaptainsModule {}
